<template>
    <b-card @click.prevent="toggleItem($event,data.id)" :class="{'d-flex flex-row':true}" no-body>
        <div class="pl-1 d-flex flex-grow-1 min-width-zero">
            <div class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p class="list-item-heading mb-1 truncate"> <i class="iconsminds-gear"></i> {{data.description}}</p>
                <p class="mb-1 text-muted w-15 w-sm-100">{{data.patient.name}}</p>
                <p class="mb-1 text-muted text-small w-15 w-sm-100">{{completedMeetings+"/"+data.nb_rdv+" "}}{{data.nb_rdv>1?"Séances":"Séance"}}</p>
                <div class="mb-1 text-muted text-small w-15 w-sm-100">
                    <b-progress style="height:10px;border:1px solid #ddd;" >
                        <b-progress-bar :value="calculeProgress" variant="theme-5"></b-progress-bar>
                    </b-progress>
                </div>
                <p class="mb-1 text-muted text-small w-15 w-sm-100" style="letter-spacing: 1px;">{{priceGived.toLocaleString('en-us')+" DH"}} <span class="mx-2">/</span> <b>{{parseFloat(data.prixtotale).toLocaleString('en-US')+" DH"}}</b></p>
            </div>
            <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
                <b-button @click.stop="visitItem()" class="mb-1 mr-1" variant="primary"><i class="simple-icon-menu"></i></b-button>
                <b-button @click.stop="deleteItem()" class="mb-1" variant="danger"><i class="simple-icon-trash"></i></b-button>
            </div>
        </div>
    </b-card>
</template>
<script>
export default {
  props: ['data', 'selectedItems'],
  methods: {
    toggleItem (event, itemId) {
      this.$emit('toggle-item', event, itemId)
    },
    visitItem(){
      this.$router.push({name:"rdv",params:{id:this.data.id}})
    },
    deleteItem(){
      this.$emit("delete",true)
    }
  },
  computed:{
    calculeProgress(){
        let max = this.data.nb_rdv
        let complete = 0
        for(let i=0;i<this.data.rdvs.length;i++){
            if(this.data.rdvs[i].isconfirmed){
                complete++
            }
        }
        let total = (complete*100)/max
        return total || 1
    },
    priceGived(){
        let price = 0
        for(let i=0;i<this.data.rdvs.length;i++){
            price = price + parseInt(this.data.rdvs[i].price_gived)
        }
        return price
    },
    completedMeetings(){
        let complete = 0
        for(let i=0;i<this.data.rdvs.length;i++){
            if(this.data.rdvs[i].isconfirmed){
                complete++
            }
        } 
        return complete
    }
  }
}
</script>
